import { useState, useEffect } from 'react'
import { Select, SelectOptionType } from '@eltoro-ui/components'

//Value is accepted in seconds so, Day # * 86400 = result
export const includedTimeOptions: SelectOptionType[] = [
  {
    label: '1 Day',
    value: '86400',
  },
  {
    label: '2 Days',
    value: '172800',
  },
  {
    label: '3 Days',
    value: '259200',
  },
  {
    label: '4 Days',
    value: '345600',
  },
  {
    label: '7 Days',
    value: '604800',
  },
  {
    label: '14 Days',
    value: '1209600',
  },
  {
    label: '30 Days',
    value: '2592000',
  },
  {
    label: '60 Days',
    value: '5184000',
  },
  {
    label: '90 Days',
    value: '7776000',
  },
  {
    label: '180 Days',
    value: '15552000',
  },
]

interface IncludedTimeInputProps {
  onChange?: (option: SelectOptionType) => void
  defaultValue?: SelectOptionType | undefined
}

export const IncludedTimeInput = ({
  onChange,
  defaultValue = { label: '180 Days', value: '15552000' },
}: IncludedTimeInputProps) => {
  const [
    selectedIncludedTime,
    setSelectedIncludedTime,
  ] = useState<SelectOptionType>(defaultValue)

  // Set initial value on mount
  useEffect(() => {
    if (onChange) {
      onChange(defaultValue)
    }
  }, [])

  const handleChange = (option: SelectOptionType | undefined) => {
    if (option) {
      setSelectedIncludedTime(option)
      onChange?.(option)
    }
  }

  return (
    <span
      // aria-label="Defines how long IP addresses remain eligible for retargeting after being captured."
      data-tooltip="bottom"
      style={{ zIndex: 1000 }}
    >
      <p className="mb-1 text-xs">
        Defines how long IP addresses remain eligible for retargeting after
        being captured.
      </p>
      <Select
        placeholder="Select Timeframe"
        options={includedTimeOptions}
        selectedOption={selectedIncludedTime}
        onChange={handleChange}
        maxHeight={250}
        clearButton={false}
      />
    </span>
  )
}
